<template lang="pug">
  div
    vue-recaptcha(ref='recaptcha' @verify="Verify" sitekey='6Lf9KQYgAAAAAKbRjQjA8rTxDrugBnTC5vKmhsJ8')

</template>

<script>

import { VueRecaptcha } from 'vue-recaptcha';


export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      propuesta: {},
      verificarCaptcha: false
    }
  },
  methods: {
    onSubmit(event) {
      console.log(event)
      event.preventDefault()
      alert(JSON.stringify(this.form))
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form= {}

      // Trick to reset/clear native browser form validation state

    },

    Verify (response){
      this.verificarCaptcha = true
      console.log(response)
    }
  }
}
</script>
